import { useCallback, useEffect, useState } from 'react'

import { DrawingToolbar } from './DrawingToolbar'
import { StatusBar } from './StatusBar'
import { TopToolbar } from './TopToolbar'
import { WatchlistPanel } from './WatchlistPanel'

import { ChartGrid } from '@/components/chart'
import { GlobalSearch } from '@/components/search'
import { SettingsPanel } from '@/components/settings/SettingsPanel'
import { useLayoutStore } from '@/stores/layoutStore'

export function AppShell() {
  const [searchOpen, setSearchOpen] = useState(false)
  const [settingsOpen, setSettingsOpen] = useState(false)
  const { watchlistOpen } = useLayoutStore()

  const openSearch = useCallback(() => setSearchOpen(true), [])
  const closeSearch = useCallback(() => setSearchOpen(false), [])

  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault()
        setSearchOpen((v) => !v)
      }
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [])

  return (
    <div className="flex h-screen w-screen flex-col overflow-hidden bg-tv-bg-primary text-tv-text-primary">
      <TopToolbar onSearchOpen={openSearch} onSettingsOpen={() => setSettingsOpen(true)} />

      <div className="flex flex-1 overflow-hidden">
        <DrawingToolbar />

        <main className="flex flex-1 flex-col overflow-hidden">
          <ChartGrid />
        </main>

        {watchlistOpen && <WatchlistPanel />}
      </div>

      <StatusBar />

      <GlobalSearch open={searchOpen} onClose={closeSearch} />
      {settingsOpen && <SettingsPanel onClose={() => setSettingsOpen(false)} />}
    </div>
  )
}
